<template>
    <div>
      <div
        class="uk-flex uk-flex-middle uk-grid-small search-results-list" uk-grid
        v-for="(loyaltyItem, $key) in loyalty"
        v-bind:key="$key"
        v-bind:loyaltyItem="loyaltyItem.id"
        v-on:click="clickListItem(loyaltyItem.id, loyaltyItem.location_id, $event)"
      >
        <div class="logo uk-width-1-5 uk-text-center">
          <img :src="loyaltyItem.rewardable_image" alt="" style="max-width: 25vw; max-height: 11vh;">
        </div>
        <div class="uk-width-3-5" style="width:70%!important; padding-left: 16vw; overflow: hidden; text-overflow:ellipsis;">
          <span class="font-size-14pt uk-bold">{{ loyaltyItem.name }}</span><br/>
          <span class="font-size-8pt" style="/*white-space: nowrap;*/">
            <span v-if="loyaltyItem.location_address1 !== '' && loyaltyItem.location_address1 !== null ">{{ loyaltyItem.location_address1 }},</span>
            <span v-if="loyaltyItem.location_locality !== '' && loyaltyItem.location_locality !== null">{{ loyaltyItem.location_locality }},</span>
            <span v-if="loyaltyItem.location_region !== '' && loyaltyItem.location_region !== null">{{ loyaltyItem.location_region }}</span>
          </span>
        </div>
        <div class="next uk-width-1-5 uk-text-right" style="width: 10% !important;">
          <img src="../../assets/images/right-arrow-grey.png" width="27" height="27">
        </div>
      </div>
    </div>
</template>

<script>
import Hub from '../../events/Hub'
import scrollPointMixin from '../../mixins/scrollPointMixin'

export default {
  mixins: [scrollPointMixin],
  props: ['results'],
  name: 'SearchResultsLoyalty',
  methods: {
    clickListItem: function (itemId, locationId, event) {
      this.saveClickLocation(event)
      this.$router.push('/loyalty/' + itemId + '/location/' + locationId)
      Hub.$emit('click-list-item')
    },
    getStoreId (loyalty) {
      return loyalty.stores && loyalty.stores.data.length > 0 ? loyalty.stores.data[0].id : undefined
    },
    getAddress (loyalty) {
      return loyalty.stores && loyalty.stores.data.length > 0 ? loyalty.stores.data[0].address1 : ''
    },
    getLocality (loyalty) {
      return loyalty.stores && loyalty.stores.data.length > 0 ? loyalty.stores.data[0].locality : ''
    },
    getRegion (loyalty) {
      return loyalty.stores && loyalty.stores.data.length > 0 ? loyalty.stores.data[0].region : ''
    }
  },
  computed: {
    loyalty () {
      return this.results.map(item => {
        let newItem = {...item}

        newItem.location_id = this.getStoreId(item)
        newItem.location_address1 = this.getAddress(item)
        newItem.location_locality = this.getLocality(item)
        newItem.location_region = this.getLocality(item)

        return newItem
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Search/SearchResultsLoyalty.vue